import { render } from "./ModalButtons.vue?vue&type=template&id=e0b11cf0&scoped=true"
import script from "./ModalButtons.vue?vue&type=script&lang=js"
export * from "./ModalButtons.vue?vue&type=script&lang=js"

import "./ModalButtons.vue?vue&type=style&index=0&id=e0b11cf0&scoped=true&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b11cf0"]])

export default __exports__